import React, { useCallback, useEffect, useState } from "react";
import { Button, Breadcrumbs, Link, Typography, CircularProgress } from "@material-ui/core";
import { Form, Input, DatePicker, Radio } from "antd";
import dayjs from "dayjs";
import UpdateFile from "@/components/UpdateFile";
import useStyles from "../styles/accountCenterStyle.js";
import useFormStyles from "../styles/formStyle.js";
import { useTranslation } from "../langs/useTranslation";
import { useParams } from "react-router-dom";
import {
  createAnnouncement,
  getAnnouncementInfo,
  updateAnnouncement
} from "@/apis/announcementApi";
import { useHistory } from "react-router-dom";
import SelectCompany from "@/components/SelectCompany";
import moment from "moment";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  },
  wrapperCol: {
    xs: {
      span: 24
    },
    sm: {
      span: 24
    }
  }
};
const formTimeItemLayout = {
  labelCol: {
    xs: {
      span: 12
    },
    sm: {
      span: 24
    }
  },
  wrapperCol: {
    xs: {
      span: 12
    },
    sm: {
      span: 24
    }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};

const range = (start, end) => {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
};

const CreateAnnouncement = () => {
  const classes = useStyles();
  const formClassName = useFormStyles();
  const history = useHistory();
  const { t } = useTranslation("devicesGroups");
  const { announcementId, type } = useParams();
  const [form] = Form.useForm();
  const disabled = type === "view";

  const [loading, setLoading] = useState(false)

  const [fileList, setFileList] = useState("[]");

  const getInfo = useCallback(async () => {
    const res = await getAnnouncementInfo({ id: announcementId });
    const { info } = res;
    const config = JSON.parse(info.config);

    form.setFieldsValue({
      ...info,
      popup: config.popup,
      isScroll: config.is_scroll,
      sendMail: config.send_mail,
      sendMessage: config.send_message,
      receiverId: info.receivers || [],
      startTime: moment(Number(info.startTime)),
      endTime: moment(Number(info.endTime)),
      sendTime: moment(Number(info.sendTime))
    });
  }, [announcementId, form]);

  const disabledDate = current => {
    return current && current < moment().subtract(1, "days").endOf("day");
  };

  const disabledDateTime = time => {
    const currentData =
      moment().format("YYYY-MM-DD") === moment(time).format("YYYY-MM-DD");

    const hour = moment().hours();
    const minute = moment().minutes();
    const second = moment().seconds();

    const selectHour = moment(time).hours();
    const selectMinute = moment(time).minutes();

    return {
      disabledHours: () => (currentData ? range(0, hour) : []),
      disabledMinutes: () =>
        currentData && selectHour <= hour ? range(0, minute) : [],
      disabledSeconds: () =>
        currentData && selectHour <= hour && selectMinute <= minute
          ? range(0, second)
          : []
    };
  };

  const onFinish = async values => {
    setLoading(true)
    const params = { ...values };
    const saveFn = announcementId ? updateAnnouncement : createAnnouncement;
    if (announcementId) {
      params.id = announcementId;
    }

    params.startTime = dayjs(params.startTime).valueOf();
    params.endTime = dayjs(params.endTime).valueOf();
    params.sendTime = params.sendTime
      ? dayjs(params.sendTime).valueOf()
      : dayjs().valueOf();

    params.config = JSON.stringify({
      popup: values.popup,
      is_scroll: values.isScroll,
      send_mail: values.sendMail,
      send_message: values.sendMessage
    });
    delete params.isScroll;
    delete params.sendMail;
    delete params.sendMessage;
    delete params.popup;

    if (values.receiverId) {
      params.receiverId = JSON.stringify(
        values.receiverId.map(item => item.receiverId)
      );
    }

    params.s3Path = values.s3Path || "[]";
    try {
      const res = await saveFn(params);
      if (res) {
        history.push("/announcement");
      }
    } catch (e) {

    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (announcementId) {
      getInfo();
    }
  }, [getInfo, announcementId]);

  return (
    <div className={classes.root}>
      <main className={classes.announcementContent}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/announcement">
            {t({ defaultMessage: "返回公告列表" })}
          </Link>
          <Typography color="textPrimary">
            {t({ defaultMessage: "新建公告" })}
          </Typography>
        </Breadcrumbs>
        <div className={classes.contentSection}>
          <div>
            <Form
              {...formItemLayout}
              className={formClassName.formContent}
              form={form}
              name="register"
              onFinish={onFinish}
              initialValues={{
                receiverType: 1,
                // config: {
                isScroll: false,
                sendMail: false,
                sendMessage: false,
                popup: false
                // },
              }}
              scrollToFirstError
            >
              <div className={classes.contentTitleSection}>
                <Typography variant="h5">
                  {disabled
                    ? t({ defaultMessage: "查看公告" })
                    : announcementId
                    ? t({ defaultMessage: "编辑公告" })
                    : t({ defaultMessage: "新建公告" })}
                </Typography>

                <div style={{ display: "flex" }}>
                  <Form.Item
                    {...tailFormItemLayout}
                    style={{ marginBottom: 0, marginRight: 20 }}
                  >
                    <Button
                      variant="contained"
                      type="submit"
                      color="primary"
                      htmlType="submit"
                      disabled={disabled || loading}
                      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                      {t({ defaultMessage: "确认" })}
                    </Button>
                  </Form.Item>
                  <Form.Item
                    {...tailFormItemLayout}
                    style={{ marginBottom: 0 }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => history.push("/announcement")}
                    >
                      {t({ defaultMessage: "取消" })}
                    </Button>
                  </Form.Item>
                </div>
              </div>

              <Typography variant="h6" style={{ marginBottom: 8 }}>
                {t({ defaultMessage: "基本信息" })}
              </Typography>

              <Form.Item
                name="announcementName"
                label={t({ defaultMessage: "公告标题" })}
                rules={[
                  {
                    required: true,
                    message: t({ defaultMessage: "公告标题为必填" })
                  },
                  () => ({
                    async validator(_, value) {
                      if (value && value.length > 50) {
                        throw new Error(
                          t({ defaultMessage: "公告标题不得超过30字符" })
                        );
                      }
                    }
                  })
                ]}
              >
                <Input
                  maxLength={30}
                  disabled={disabled}
                  placeholder={t({ defaultMessage: "限制30字以内" })}
                />
              </Form.Item>

              <Form.Item
                name="announcementContent"
                label={t({ defaultMessage: "公告内容" })}
                rules={[
                  {
                    required: true,
                    message: t({ defaultMessage: "公告内容为必填" })
                  }
                ]}
              >
                <Input.TextArea
                  rows={6}
                  showCount
                  maxLength={200}
                  disabled={disabled}
                />
              </Form.Item>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Form.Item
                  name="startTime"
                  label={t({ defaultMessage: "开始时间" })}
                  rules={[
                    {
                      required: false,
                      message: t({ defaultMessage: "请选择开始时间" })
                    }
                  ]}
                  style={{ width: "47%" }}
                >
                  <DatePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    showTime={{ defaultValue: dayjs("00:00:00", "HH:mm:ss") }}
                    style={{ width: "100%" }}
                    disabled={disabled}
                  />
                </Form.Item>

                <Form.Item
                  name="endTime"
                  label={t({ defaultMessage: "结束时间" })}
                  rules={[
                    {
                      required: false,
                      message: t({ defaultMessage: "请选择结束时间" })
                    }
                  ]}
                  style={{ width: "47%" }}
                >
                  <DatePicker
                    format="YYYY-MM-DD HH:mm:ss"
                    showTime={{ format: "HH:mm:ss" }}
                    style={{ width: "100%" }}
                    disabled={disabled}
                  />
                </Form.Item>
              </div>

              <Form.Item
                name="s3Path"
                label={t({ defaultMessage: "附件" })}
                rules={[
                  {
                    required: false,
                    message: t({ defaultMessage: "请上传附件" })
                  }
                ]}
              >
                <UpdateFile
                  value={fileList}
                  onChange={setFileList}
                  disabled={disabled}
                />
              </Form.Item>

              <Form.Item
                name="receiverType"
                label={t({ defaultMessage: "接收对象" })}
                rules={[
                  {
                    required: true,
                    message: t({ defaultMessage: "请选择接收对象" })
                  }
                ]}
              >
                <Radio.Group disabled={disabled}>
                  <Radio value={1}>{t({ defaultMessage: "所有用户" })}</Radio>
                  <Radio value={2}>{t({ defaultMessage: "指定用户" })}</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  if (getFieldValue("receiverType") === 2) {
                    return (
                      <Form.Item
                        name="receiverId"
                        rules={[
                          {
                            required: true,
                            message: t({ defaultMessage: "请选择指定用户" })
                          }
                        ]}
                      >
                        <SelectCompany disabled={disabled} />
                      </Form.Item>
                    );
                  }
                }}
              </Form.Item>

              <Typography variant="h6" style={{ marginBottom: 8 }}>
                {t({ defaultMessage: "公告配置" })}
              </Typography>

              <div className={classes.announcementConfig}>
                <Form.Item
                  name="isScroll"
                  label={t({ defaultMessage: "滚动播放" })}
                  rules={[
                    {
                      required: false,
                      message: t({ defaultMessage: "请选择滚动播放" })
                    }
                  ]}
                >
                  <Radio.Group disabled={disabled}>
                    <Radio value={true}>{t({ defaultMessage: "是" })}</Radio>
                    <Radio value={false}>{t({ defaultMessage: "否" })}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name="sendMail"
                  label={t({ defaultMessage: "同时发送邮件" })}
                  rules={[
                    {
                      required: false,
                      message: t({ defaultMessage: "请选择是否同时发送邮件" })
                    }
                  ]}
                >
                  <Radio.Group disabled={disabled}>
                    <Radio value={true}>{t({ defaultMessage: "是" })}</Radio>
                    <Radio value={false}>{t({ defaultMessage: "否" })}</Radio>
                  </Radio.Group>
                </Form.Item>
                <Form.Item
                  name="popup"
                  label={t({ defaultMessage: "弹窗" })}
                  rules={[
                    {
                      required: false,
                      message: t({ defaultMessage: "请选择是否弹窗" })
                    }
                  ]}
                >
                  <Radio.Group disabled={disabled}>
                    <Radio value={true}>{t({ defaultMessage: "是" })}</Radio>
                    <Radio value={false}>{t({ defaultMessage: "否" })}</Radio>
                  </Radio.Group>
                </Form.Item>
                {/*             <Form.Item
                  name="sendMessage"
                  label={t({ defaultMessage: "同时发送短信" })}
                  rules={[
                    {
                      required: false,
                      message: t({ defaultMessage: "请选择是否同时发送短信" })
                    }
                  ]}
                >
                  <Radio.Group disabled={disabled}>
                    <Radio value={true}>{t({ defaultMessage: "是" })}</Radio>
                    <Radio value={false}>{t({ defaultMessage: "否" })}</Radio>
                  </Radio.Group>
                </Form.Item>*/}
              </div>

              <Form.Item
                name="sendTime"
                label={t({ defaultMessage: "发送时间" })}
                rules={[
                  {
                    required: false,
                    message: t({ defaultMessage: "请选择发送时间" })
                  }
                ]}
                style={{ width: "47%" }}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  disabledDate={disabledDate}
                  disabledTime={disabledDateTime}
                  showTime={{
                    format: "HH:mm:ss"
                    // defaultValue: moment(
                    //   `${moment().hours() + 1}:00:00`,
                    //   "HH:mm:ss"
                    // )
                  }}
                  style={{ width: "100%" }}
                  disabled={disabled}
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CreateAnnouncement;
